<template>
  <button
    type="button"
    class="block border-2 border-nucleus-primaryBlue bg-white text-nucleus-text hover:bg-nucleus-primaryMouseOver hover:text-white p-1 text-sm text-center shadow-md rounded-full transition relative"
  >
    <span
      v-if="!loading"
      class="absolute w-full h-full top-0 left-0 rounded-full bg-nucleus-primaryBlue text-white flex justify-center items-center"
    >
      <span
        class="loader ease-linear rounded-full border-2 border-t-2 border-nucleus-primaryMouseOver h-6 w-6 animate-spin"
      ></span
    ></span>
    {{ name }}
  </button>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    name: String,
    loading: Boolean,
  },
})
export default class ButtonRefresh extends Vue {}
</script>

<style lang="scss" scoped>
.loader {
  border-top-color: #ffffff;
}
</style>
